export enum TKey {
  ActivityStateSetToDone = 0,
  ActivityStateSetToPlanning = 1,
  ActivityEmojiChanged = 2,
  ActivityDescriptionChanged = 3,
  ActivityTitleChange = 4,
  ActivityModuleAdded = 5,
  ActivityRestoredCard = 6,
  ActivityArchivedCard = 7,
  ActivityMovedCard = 8,
  ActivityUpdatedTextInPoll = 9,
  ActivityPlanInfoDescriptionUpdated = 10,
  ActivityPlanInfoImageUpdated = 11,
  ActivityUpdatedDescriptionInLocation = 12,
  ActivityUpdatedPositionInLocation = 13,
  ActivityInfoTextUpdated = 14,
  ActivityPollVotedFor = 15,
  // ActivityPollStartedVoting = 16,
  ActivityPollOptionUpdated = 17,
  ActivityCheckboxAssignedTo = 18,
  ActivityCheckboxAssignedRemoved = 19,
  ActivityCheckboxLabelUpdated = 20,
  ActivityCheckboxCompleted = 21,
  ActivityCheckboxReset = 22,
  ActivityCalendarDatesSet = 23,
  ActivityDateDueAssignedTo = 24,
  ActivityDateDueAssignedRemoved = 25,
  ActivityDateDueDescriptionUpdated = 26,
  ActivityDateDueCompleted = 27,
  ActivityDateDueReset = 28,
  ActivityCheckboxAdded = 29,
  ActivityRatingSet = 30,
  ActivityLocationAdded = 31,
  ActivityPollOptionAdded = 32,
  ActivityCommentAdded = 33,
  ActivityPollStoppedVotingFor = 34,
  ActivityDataWithLabelDeleted = 35,
  ActivityExpensesExpenseAdded = 36,
  ActivityExpensesSettlementAdded = 37,
  ActivityTrackerItemAdded = 39,
  ActivityExpensesExpenseUpdated = 40,
  ActivityUpdatedLocation = 41,
  ActivityRsvpUpdated = 42,
  ActivityModuleCopied = 43,
  ActivityReminderAssignedTo = 44,
  ActivityReminderAssignedRemoved = 45,
  ActivityReminderDescriptionUpdated = 46,
  ActivityReminderCompleted = 47,
  ActivityReminderReset = 48,
  BusinessFeedItemPosted = 49,
  BusinessFeedCommentPosted = 50,
  BusinessFeedCommentReplyPosted = 51,
}
